<script lang="ts" setup>
// 主要是用于后台管理的操作栏，用于和NuxtLink组件保持一致的样式
// 如果使用<a-button>组件，则和NuxtLink组件的样式不一致
</script>

<template>
  <a href="javascript:void(0)"><slot></slot></a>
</template>
